import { Descriptions } from 'antd';
import React from 'react';

import { Gacha } from '@/api-client/generated/models';
import '@/Gacha/styles/gachaInfoDescriptions.css';

export type GameInfoDescriptionItemType = {
  label: string;
  render?: (v: any) => string;
};

type GachaInfoDescriptionsProps = {
  title: string;
  gacha: Gacha;
  itemsType: { [key: string]: GameInfoDescriptionItemType };
};

const GachaInfoDescriptions: React.FC<GachaInfoDescriptionsProps> = ({ title, gacha, itemsType }) => (
  <Descriptions title={title} column={1} bordered>
    {Object.keys(itemsType)
      .filter((key) => typeof gacha[key] !== 'undefined')
      .map((key) => {
        const itemType = itemsType[key];
        return (
          <Descriptions.Item label={itemType.label} key={key}>
            {itemType.render ? itemType.render(gacha[key]) : gacha[key]}
          </Descriptions.Item>
        );
      })}
  </Descriptions>
);

export default GachaInfoDescriptions;
